import { createReducer, on } from "@ngrx/store";
import { createTypes, CreateTypes } from "../utilities/Constants";
import { SharedActions } from "../actions";
import { ViewPageActions } from "../../transaction-view/actions";

export const previousContextKey = 'previousCreateTypeInContext';

export const initialPreviousCreateTypeInContextState: CreateTypes = createTypes.empty;

export const previousContextReducer = createReducer(
  initialPreviousCreateTypeInContextState,
  on(SharedActions.updatePreviousContext, (state, {createType}) => {
    return createType;
  }),
  on(SharedActions.previousContextNavigation,
    ViewPageActions.backButtonClicked,
    ViewPageActions.backButtonClickedFromMsv,
    () => {
    return createTypes.empty;
  })
);
